"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Styles = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const Text = _a => {
  var {
      children,
      type
    } = _a,
    props = __rest(_a, ["children", "type"]);
  switch (type) {
    case 'h1':
      return /*#__PURE__*/_react.default.createElement(Styles.H1, Object.assign({}, props), children);
    case 'h2':
      return /*#__PURE__*/_react.default.createElement(Styles.H2, Object.assign({}, props), children);
    case 'h3':
      return /*#__PURE__*/_react.default.createElement(Styles.H3, Object.assign({}, props), children);
    case 'p':
      return /*#__PURE__*/_react.default.createElement(Styles.Paragraph, Object.assign({}, props), children);
    case 'label':
      return /*#__PURE__*/_react.default.createElement(Styles.Label, Object.assign({}, props), children);
    case 'help':
      return /*#__PURE__*/_react.default.createElement(Styles.Help, Object.assign({}, props), children);
    default:
      return /*#__PURE__*/_react.default.createElement(Styles.Span, null, children);
  }
};
Text.propTypes = {
  children: _propTypes.default.node,
  hasError: _propTypes.default.bool,
  htmlFor: _propTypes.default.string,
  color: _propTypes.default.string,
  type: _propTypes.default.string,
  as: _propTypes.default.string
};
Text.defaultProps = {
  children: undefined,
  hasError: false,
  htmlFor: undefined,
  color: 'grayDarker',
  type: 'span'
};
var _default = exports.default = Text;